var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"age--form__inputs",class:[_vm.isForResponsive],on:{"click":_vm.doLogin}},[_c('button',{staticClass:"age--form__fb--in",attrs:{"type":"button","aria-label":"Entrar FB"}},[_vm._v("CLICK AQUÍ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }